import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import MainLogo from './elements/MainLogo';
import MainButton from '@components/elements/MainButton';

// TODO

// Update scrolling background color to be more responsive to light mode or dark mode.
// Update fonts and link sizes to match the new design system.
// Stop Navigation at the footer

// --- SECTIONS

const NavSectionWrapper = styled.div`
	width: 90%;
	height: 100%;
	max-width: 1320px;
	margin: 0 auto;
	display: ${({ display }) => display};
	padding: ${({ padding }) => padding};
`;

const NavSection = ({
	children,
	display,
	padding,
	className,
	onMouseLeave,
}) => {
	return (
		<NavSectionWrapper
			onMouseLeave={onMouseLeave}
			display={display}
			padding={padding}
			className={className}
		>
			{children}
		</NavSectionWrapper>
	);
};

const Container = styled.div`
	min-width: 100vw;
	background-color: ${props =>
		props.isScrolled ? 'rgba(255,255, 255, 0.5)' : 'transparent'};
	backdrop-filter: ${props => (props.isScrolled ? 'blur(12px)' : 'none')};
	height: ${({ theme }) => theme.fixedHeights.navBar}px;
`;

const TopNavBarInner = styled(NavSection)`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
`;

const MainMenu = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	width: 100%;
	justify-content: space-between;
`;

export default React.memo(({ noLinkLogo, simpleCta, darkMode, className }) => {
	const [isScrolled, setIsScrolled] = useState(false);
	// scrolling will set a white background
	const reverseColor = darkMode && !isScrolled;

	useEffect(() => {
		const handleScroll = () => {
			const scrollTop = window.scrollY;
			setIsScrolled(scrollTop > 50);
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<Container
			key="main-menu-container"
			className={`${className} main-menu-container`}
			isScrolled={isScrolled}
		>
			<TopNavBarInner className="main-menu-container-inner">
				<MainMenu>
					<MainLogo noLinkLogo={noLinkLogo} reverse={reverseColor} />
					{simpleCta && <MainButton linkUrl={'/sign-in'}>Sign In</MainButton>}
				</MainMenu>
			</TopNavBarInner>
		</Container>
	);
});
